export default {
  init() {
    
    let currentSlide = 0;

    function slideAlternatives(direction) {
      const slider = document.querySelector('.sh-alternatives-slider');
      const wrapper = document.querySelector('.sh-alternatives-slider-wrapper');
      const tiles = slider.querySelectorAll('.sh-alternatives-tile');
      const totalTiles = tiles.length;

      if (totalTiles === 0) return;

      const wrapperWidth = wrapper.offsetWidth;
      const gap = 16;
      
      let totalVisibleWidth = 0;
      let tilesVisible = 0;
      
      for (let i = 0; i < totalTiles; i++) {
        const tileWidth = tiles[i].offsetWidth;
        const nextWidth = totalVisibleWidth + tileWidth + (i > 0 ? gap : 0);
        
        if (nextWidth <= wrapperWidth) {
          totalVisibleWidth = nextWidth;
          tilesVisible++;
        } else {
          break;
        }
      }
      
      const maxSlide = Math.max(0, totalTiles - tilesVisible);
      currentSlide = Math.max(0, Math.min(maxSlide, currentSlide + direction));
      
      let translateX = 0;
      for (let i = 0; i < currentSlide; i++) {
        translateX += tiles[i].offsetWidth + gap;
      }
      
      slider.style.transform = `translateX(-${translateX}px)`;
      slider.style.transition = 'transform 0.3s ease';
    }

    $('.sh-alternatives-slider-nav .sh-alt-slide-right').click(function () {
      slideAlternatives(1);
    });

    $('.sh-alternatives-slider-nav .sh-alt-slide-left').click(function () {
      slideAlternatives(-1);
    });

    window.addEventListener('resize', function () {
      const slider = document.querySelector('.sh-alternatives-slider');
      if (slider) {
        slider.style.transform = 'translateX(0)';
        slider.style.transition = '';
      }
      currentSlide = 0;
    });

  },
  finalize() {
  },
};